import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import './SearchFilter.css';
import { toast } from 'react-toastify';

const SearchComponent = () => {
    const [makers, setMakers] = useState([]);
    const [selectedCar, setSelectedCar] = useState('');
    const [selectedMaker, setSelectedMaker] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [models, setModels] = useState([]);
    const [cars, setCars] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCars = async () => {
            try {
                const response = await axios.get('https://serve.servebiznes.com/api/all-cars');
                if (response.data && Array.isArray(response.data.cars)) {
                    setCars(response.data.cars);
                } else {
                    console.error('Unexpected response data format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching car data:', error);
            }
        };

        fetchCars();
    }, []);

    useEffect(() => {
        const fetchMakers = async () => {
            if (!selectedCar) return;
            try {
                const response = await axios.get(`https://serve.servebiznes.com/api/all-cars-maker?car_id=${selectedCar}`);
                if (response.data && Array.isArray(response.data.maker)) {
                    setMakers(response.data.maker);
                } else {
                    console.error('Unexpected response data format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching makers:', error);
            }
        };

        fetchMakers();
    }, [selectedCar]);

    useEffect(() => {
        const fetchModels = async () => {
            if (!selectedCar || !selectedMaker) return;
            try {
                const response = await axios.get('https://serve.servebiznes.com/api/all-cars-models', {
                    params: {
                        car_id: selectedCar,
                        maker_id: selectedMaker
                    }
                });
                if (response.data && Array.isArray(response.data.models)) {
                    setModels(response.data.models);
                } else {
                    console.error('Unexpected response data format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching models:', error);
            }
        };

        fetchModels();
    }, [selectedCar, selectedMaker]);

    const fetchCarDetails = async () => {
        console.log("Fetching details for car ID:", selectedCar);

        if (!selectedCar || !selectedMaker) {
            toast.error('Selected car ID is empty or invalid.');
            return;
        }

        try {
            const response = await axios.post('https://serve.servebiznes.com/api/get-car-img', {
                car_id: selectedCar,
                maker_id: selectedMaker
            });

            const carImages = response.data.all_images.map(img => ({
                ...img,
                url: `${response.data.imagepath}${img.car_image}`
            }));

            navigate('/product-details', { state: { carImages, selectedCarName: response.data.car_name, selectedModelName: response.data.model_name } });
        } catch (error) {
            console.error('Error fetching car images:', error);
            navigate('/product-details', { state: { error: 'An error occurred while fetching the car images.' } });
        }
    };

    return (
        <div className="container set_max_width_banner">
            <Container fluid className="set_max_width_banner search-container">
                <Row className="text-center banner">
                    <Col>
                        <h1 className='fw-bold'>Find a Service for your vehicle</h1>
                        {/* <h2 className='fw-bold text-light'>Motor Easy Pricing Charts for Selected Car</h2> */}
                    </Col>
                </Row>
                <Row className="justify-content-between  p-md-5 p-1 rounded-3">
                    {/* Form Layout: Input Fields */}
                    <Col xs={12} md={12} className="search-box-container ">
                        <Form className="search-box d-flex flex-wrap rounded-3 justify-content-between align-items-start px-md-4 py-md-5" style={{ width: "100%" }}>
                            <div className="d-flex flex-column flex-md-column flex-row w-50">
                                <div className='d-flex flex-md-row flex-column justify-content-center align-items-center py-md-2'>
                                    <div className='label_width'>
                                        <Form.Label className='float-start' htmlFor="make">Make :</Form.Label>
                                    </div>
                                    <div className='select_width' style={{ position: 'relative' }}>
                                        <Form.Group className="search-item me-md-3 mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="make" value={selectedCar} onChange={(e) => setSelectedCar(e.target.value)} style={{ paddingRight: '30px' }}>
                                                <option value="">- Make -</option>
                                                {cars.map((car) => (
                                                    <option key={car.id} value={car.id}>{car.car_name}</option>
                                                ))}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className='d-flex flex-md-row flex-column justify-content-center align-items-center py-md-2'>
                                    <div className="label_width">
                                        <Form.Label className='float-start' htmlFor="model">Model :</Form.Label>
                                    </div>
                                    <div className="select_width" style={{ position: 'relative' }}>
                                        <Form.Group className="search-item me-md-3 mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="model" value={selectedMaker} onChange={(e) => setSelectedMaker(e.target.value)} style={{ paddingRight: '30px' }}>
                                                <option value="">- Model -</option>
                                                {makers.map((maker) => (
                                                    <option key={maker.id} value={maker.id}>{maker.maker_name}</option>
                                                ))}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className='d-flex flex-md-row flex-column justify-content-center align-items-center py-md-2'>
                                    <div className="label_width">
                                        <Form.Label className='float-start' htmlFor="year">Year :</Form.Label>
                                    </div>
                                    <div className="select_width" style={{ position: 'relative' }}>
                                        <Form.Group className="search-item mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="year" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} style={{ paddingRight: '30px' }}>
                                                <option value="">- Year -</option>
                                                {models.map((model, index) => (
                                                    <option key={index} value={model.model_name}>
                                                        {model.model_name}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                {/* Additional Input Field or Blank */}
                                <div className='d-flex flex-md-row flex-column justify-content-center align-items-center py-md-2'>
                                    <div className="label_width">
                                        <Form.Label className='float-start' htmlFor="currentKm">Current Km :</Form.Label>
                                    </div>
                                    <div className="select_width" style={{ position: 'relative' }}>
                                        <Form.Group className="search-item ms-md-3 mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="currentKm" style={{ paddingRight: '30px' }}>
                                                <option value=""></option>
                                                {/* Populate more options here as needed */}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                            </div>
                            <div className="d-flex flex-column flex-md-column flex-row w-50 ">
                                {/* Additional Input Field or Blank */}
                                <div className='d-flex flex-md-row flex-column justify-content-center align-items-center'>
                                    <div className="label_width">
                                        <Form.Label className='float-start' htmlFor="engineType">Engine Type :</Form.Label>
                                    </div>
                                    <div className="select_width" style={{ position: 'relative' }}>
                                        <Form.Group className="search-item ms-md-3 mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="engineType" style={{ paddingRight: '30px' }}>
                                                <option value=""></option>
                                                {/* Add more options here */}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className='d-flex flex-md-row flex-column justify-content-center mt-3 align-items-center'>
                                    <div className="label_width">
                                        <Form.Label className='float-start' htmlFor="engineType"></Form.Label>
                                    </div>
                                    <div className="select_width" style={{ position: 'relative' }}>
                                        <Form.Group className="search-item ms-md-3 mb-3 mb-md-0" style={{ flex: 1 }}>
                                            <Form.Control as="select" id="engineType" style={{ paddingRight: '30px' }}>
                                                <option value="">Select (petro , Diesel, EV, Hybrid)</option>
                                                {/* Add more options here */}
                                            </Form.Control>
                                            {/* Dropdown Icon */}
                                            <div style={{ position: 'absolute', top: '50%', right: '25px', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                                                <i className="fas fa-chevron-down"></i>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>


                                <Button
                                    className="search-button mt-5 mx-auto"
                                    onClick={fetchCarDetails}
                                >
                                    SHOW
                                </Button>
                            </div>

                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>

    );
};

export default SearchComponent;
